import {
    CustomLogo,
} from '@atlaskit/navigation-system';
import crackleLogo from '@assets/images/CRACKLE.svg';
import crackleIcon from '@assets/images/crackle-icon.png';
import { useNavigate } from 'react-router-dom';

function MockTopBar() {
    const navigate = useNavigate();


    return (

        <CustomLogo
            href="/home"
            logo={() => <img src={crackleLogo} alt="" />}
            icon={() => <img src={crackleIcon} alt="" />}
            label="Go to home"
            onClick={(e) => {
                e.preventDefault();
                navigate('/home');
            }}
        />
    );
}

export default MockTopBar;
